import { Component } from '@angular/core';
import { RequestedPhysicalCard } from './requested-physical-card.model';

export interface PinMailer {
  status: string;
  requestDate: string;
  registrationDateTime: string;
  notificationDateTime: string;
  shippingAddress: string;
}

@Component({
  selector: 'app-detail-table',
  templateUrl: './requested-physical-card-table.component.html',
  styleUrls: ['../../../detail-screen/detail-screen.component.css'],
})
export class RequestedPhysicalCardTableComponent {
  restrictedData: boolean;
  tableColumns: string[];
  tableData: RequestedPhysicalCard[];
  emptyValuePlaceholder = '-';
  errorText: string;
  showTable: boolean;

  constructor() {
    this.tableColumns = [];
    this.tableData = [];
  }

  public statusFormat(pinMailer: PinMailer): string {
    let status = '-';
    if (pinMailer.registrationDateTime && !pinMailer.notificationDateTime) {
      status = 'Aangevraagd';
    }
    if (pinMailer.registrationDateTime && pinMailer.notificationDateTime) {
      status = 'Verzonden';
    }

    return status;
  }

  public requestedDateFormat(data: any): string {
    if (data.pinMailer) {
      return data.pinMailer.requestDate;
    } else if (data.creationDate) {
      return data.creationDate;
    } else {
      return this.emptyValuePlaceholder;
    }
  }

  getNotificationDateTime(data:any){
    let notificationDateTime = '-';
    if(data.pinMailer && data.pinMailer.status == 'Verzonden'){
      notificationDateTime = data.pinMailer.notificationDateTime;
    } else if (data.notificationPassFactoryDateTime) {
      notificationDateTime = data.notificationPassFactoryDateTime;
    }
    return notificationDateTime;
  }
  public getShippingAddress(data: any) {
    if (data.pinMailer && data.pinMailer.shippingAddress) {
      return data.pinMailer.shippingAddress;
    } else if (data.shippingAddress) {
      return data.shippingAddress;
    }
    return this.emptyValuePlaceholder;
  }

}
  